import React from 'react';
import '../../assets/css/Home.page.css';
import Content from './Content';
import {CssBaseline} from "@mui/material";
import Footer from "./Footer";

const Methodology = () => {
    return (
        <div className="home-container">
            <CssBaseline />
            <Content />
            <Footer/>
        </div>
    );
};

export default Methodology;